import React from "react";

const ThreeDot = ({ style, size = 20 }) =>
  <svg width={size} height={size} style={style} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.72938 10.5644C10.1322 10.5644 10.4588 10.2378 10.4588 9.835C10.4588 9.43218 10.1322 9.10563 9.72938 9.10563C9.32655 9.10563 9 9.43218 9 9.835C9 10.2378 9.32655 10.5644 9.72938 10.5644Z" stroke="#69687A" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M9.72938 5.45875C10.1322 5.45875 10.4588 5.1322 10.4588 4.72938C10.4588 4.32655 10.1322 4 9.72938 4C9.32655 4 9 4.32655 9 4.72938C9 5.1322 9.32655 5.45875 9.72938 5.45875Z" stroke="#69687A" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M9.72938 15.67C10.1322 15.67 10.4588 15.3434 10.4588 14.9406C10.4588 14.5378 10.1322 14.2113 9.72938 14.2113C9.32655 14.2113 9 14.5378 9 14.9406C9 15.3434 9.32655 15.67 9.72938 15.67Z" stroke="#69687A" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
  ;

export default ThreeDot;

